<template>
  <v-row class="filters--list mb-4">
    <v-col cols="12" sm="12" md="6" lg="4">
      <FilterSearch label="searchByCodeOrAddress" :fetchData="fetchRealties" />
    </v-col>
    <v-col cols="12" sm="12" md="4" lg="2">
      <FilterAutocomplete
        :label="$t('realty.filters.city')"
        :fetchData="fetchRealties"
        :items="cities"
        type="cityId"
        value="id"
      />
    </v-col>
  </v-row>
</template>

<script>
import FilterSearch from '@/components/filters/FilterSearch'
import FilterDates from '@/components/filters/FilterDates'
import FilterAutocomplete from '@/components/filters/FilterAutocomplete'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'RealtyListFilters',
  components: { FilterAutocomplete, FilterSearch, FilterDates },
  data() {
    return {
      selectedCity: null,
      searchText: null,
    }
  },
  mounted() {
    this.fetchCitiesByRealties()
  },
  computed: {
    ...mapGetters(['cities']),
  },
  methods: {
    ...mapActions(['fetchRealties', 'fetchCitiesByRealties']),

    resetForm() {
      this.$refs.form.reset()
    },
    getRealties() {
      this.$root.$emit('applyFilters')
      let params = this.preparedParams()
      this.$store.dispatch('realty/listPaginatedRealties', params)
    },
    preparedParams() {
      let params = {}
      if (this.selectedCity) {
        params.cityId = this.selectedCity
      }
      if (this.searchText) {
        params.search = this.searchText
      }
      return params
    },
  },
}
</script>
